export default __webpack_public_path__ + "static/media/faqlogo.ce00f4d1.png";